import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController, PopoverController } from '@ionic/angular';
import * as _ from 'lodash';

import { Integration, Organizer } from 'src/models';
import { AuthService } from 'src/services/auth.service';
import { SlackService } from 'src/services/slack.service';

import { ActionDropdownComponent, ActionDropdownType } from '../components/action-dropdown/action-dropdown.component';
import { INTEGRATIONS, routes } from '../constants';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.page.html',
  styleUrls: ['./integrations.page.scss'],
})
export class IntegrationsPage implements OnInit {
  integrationType: string;
  integration: Integration;
  fullRedirect: string;

  organizers: Organizer[] = [];
  organizer: Organizer;
  orgId: string;

  code: string;
  clientId: string;
  clientSecret: string;
  directoryId: string;
  errorMessage: string;
  isEnabled = false;
  isLoading = false;

  constructor(
    private navController: NavController,
    private popoverCtrl: PopoverController,
    public authService: AuthService,
    private slackService: SlackService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.integrationType = this.route.snapshot.paramMap.get('integrationType');
    this.fullRedirect = this.route.snapshot.queryParamMap.get('redirectForOAuth');

    this.route.queryParams.subscribe((params) => {
      this.code = params.code;

      if (params.state) {
        // The state should be the final destination after successfully integrating
        // We'll be redirecting from app.unthread.io (default redirect URL for any oauth stuff) over to the client's domain
        const url = params.state.split('://')[1];
        const origin = url.split('/')[0];
        window.open(
          `https://${origin}/integrations/${this.integrationType}?redirectForOAuth=${encodeURIComponent(
            params.state,
          )}&code=${this.code}`,
          '_self',
        );
      } else if (this.code) {
        this.storeOAuthCode();
      }
    });
  }

  async changeOrg() {
    const options: ActionDropdownType[] = [];

    this.organizers.forEach((org) => {
      options.push({
        label: org.name,
      });
    });

    const popover = await this.popoverCtrl.create({
      component: ActionDropdownComponent,
      componentProps: {
        options,
        callback: (idx: number, _label: string) => {
          popover.dismiss();

          const org = this.organizers[idx];

          this.organizer = org;
          this.orgId = org.objectId;
          this.isEnabled = org.slackEnabled;
        },
      },
      showBackdrop: false,
      event,
    });
    popover.present();
  }

  async storeOAuthCode() {}

  connectSlack() {
    const user = this.authService.user;
    if (!user) {
      this.goToAuth();
      return;
    }

    this.slackService.oauth(window.location.href, window.location.origin);
  }

  connect() {
    switch (this.integrationType) {
      case INTEGRATIONS.slack.url:
        this.connectSlack();
        break;
    }
  }

  viewPrivacyPolicy() {
    window.open('https://unthread.io/privacy', '_blank', 'location=yes');
  }

  goToAuth() {
    this.navController.navigateRoot(['/login'], {
      queryParams: {
        redirect: `/integrations/${this.integrationType}`,
      },
    });
  }

  goBack() {
    if (this.fullRedirect) {
      window.open(this.fullRedirect, '_self');
    } else {
      this.navController.back();
    }
  }
}
